// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'

export const makeInitialCaseSummaryState = () => ({
  caseDetailsTerrCaseId: null,
  caseSummaries: [],
  channelCaseList: [],
  openSummaryUID: null,
  pathId: null,
  selectedTerrCaseIds: [],
  showAllCases: false,
  caseOhDetailsTerrCaseId: null,
})

const initialState = fromJS({
  analysisStatusId: null, // reflects the status of the current analysis result data.
  analysisTypes: [], // TODO - do we need to store these?
  bandOptions: [],
  caseSummary: makeInitialCaseSummaryState(),
  groupedFrequencyPlans: [],
  highlightedPathIds: [],
  modalConfig: null,
  propagationModels: [],
  protectionTypes: [], // used on the AFS Result Filter form
  visibleGroupedFrequencyPlans: [],
})

export default initialState
